// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"18":"3fbfaa553c79f6d4a1e7","870":"0806ab1409f099352b0a","888":"28544c56c9e3cb6c30af"}[chunkId] + ".css";
};